import { StyledEngineProvider, createTheme } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { URL_ROLES } from "auth/roles";
import EntaAppbar from "common/components/EntaAppbar";
import EntaLeavingPrompt from "common/components/EntaLeavingPrompt";
import { Messages } from "common/components/Messages";
import Build from "developer";
import { env } from "env";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import "./App.css";
import PrivateRoute from "./auth/components/private-route";
import { ErrorHandler } from "./common/components/ErrorHandler";

//customize zIndex to be compliant with kendo
const theme = createTheme({
  zIndex: {
    modal: 10100,
  },
  components: {
    MuiAppBar: {
      defaultProps: {
        color: "inherit",
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "standard",
      },
    },
  },
});
function App() {
  const basename = env.REACT_APP_ROOT_PATH || "/build";

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ErrorHandler>
          <Router basename={basename}>
            <EntaAppbar />
            <Switch>
              <PrivateRoute path="/" roles={URL_ROLES.Developer.Edit}>
                <EntaLeavingPrompt>
                  <Build />
                </EntaLeavingPrompt>
              </PrivateRoute>
            </Switch>
          </Router>
        </ErrorHandler>
        <Messages />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
